import { Container } from '@/atoms';
import { Faq } from '@/molecules';
import { FlexibleContent, HeroSlider } from '@/templates';
import { getBaseLayout } from '@/layouts/BaseLayout';

import { getInitialProps } from '@/lib/graphql/api';
import {
  FlexibleContentBlocks,
  pagePropsPartial,
  sliderHero,
} from '@/lib/graphql/partials';
import { PageQuery } from '@/lib/graphql/querys';
import { pagePropsServerTransformer } from '@/lib/graphql/transformers';

import type { NextPageWithLayout } from './_app';

const Subscriptions: NextPageWithLayout = ({
  page: { faq, flexibleContent, hero },
}: any) => (
  <>
    <HeroSlider hero={hero} />
    <FlexibleContent type="Page" flexible={flexibleContent.flexible} />

    <Container wrapper backgroundColor="bg-bg-secondary">
      <div className="u-headline u-headline--h2 mx-auto mb-10" id="faqs">
        PREGUNTAS FRECUENTES
      </div>

      {faq.faq.map((itm: any, index: number) => (
        <Faq question={itm.title} key={index} open>
          {itm.preguntas.map((innerItm: any, index: number) => (
            <Faq question={innerItm.question} key={index} variant="white">
              {innerItm.answer}
            </Faq>
          ))}
        </Faq>
      ))}
    </Container>
  </>
);

export async function getStaticProps() {
  const content = `
  page(id: $slug, idType: URI) {
    faq {
      faq {
        title
        preguntas {
          question
          answer
        }
      }
    }
    flexibleContent: ${FlexibleContentBlocks('Page')}
    hero: ${sliderHero('Page')}
  }
`;
  const Query = PageQuery(pagePropsPartial, content);

  return await pagePropsServerTransformer({
    staticProps: await getInitialProps(Query, { slug: 'suscripciones' }),
    type: 'Page',
    path: 'suscripciones',
  });
}

Subscriptions.getLayout = getBaseLayout;

export default Subscriptions;
